(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elli-announcement-marquee"] && !Shopify.designMode) return;
  try {
    
  class ElliMarquee extends HTMLElement {
    connectedCallback() {
      this.observer = new ResizeObserver(() => this.update());
      const group = this.querySelector('.elli-marquee__group');
      if (group) this.observer.observe(group);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    update() {
      const group = this.querySelector('.elli-marquee__group');
      const speed = Number(this.dataset.speed) || 30;
      if (!group) return;
      this.style.setProperty('--elli-marquee-duration', `${group.offsetWidth / speed}s`);
    }
  }

  if (!customElements.get('elli-marquee')) customElements.define('elli-marquee', ElliMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elli-collection-articles"] && !Shopify.designMode) return;
  try {
    
  class ElliArticleSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.elli-collection-articles__track');
      this.onClick = (event) => {
        const button = event.target.closest('.elli-collection-articles__arrow');
        if (button) this.step(Number(button.dataset.direction));
      };
      // Im Theme-Editor die ausgewählte Karte ins Bild holen
      this.onBlockSelect = (event) => {
        if (this.track.contains(event.target)) this.track.scrollTo({ left: event.target.offsetLeft });
      };
      this.addEventListener('click', this.onClick);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    // Blättert um eine Karte; hinter der letzten folgt die erste und umgekehrt,
    // wie wrapAround in Broadcasts Flickity-Slider.
    step(direction) {
      const cards = [...this.track.children];
      if (cards.length < 2) return;
      const offset = this.track.scrollLeft;
      let current = 0;
      cards.forEach((card, index) => {
        if (Math.abs(card.offsetLeft - offset) < Math.abs(cards[current].offsetLeft - offset)) current = index;
      });
      const target = cards[(current + direction + cards.length) % cards.length];
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: target.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  }

  if (!customElements.get('elli-article-slider')) customElements.define('elli-article-slider', ElliArticleSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
